<div>
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h2>{{title}}</h2>
  </div>
  <main class="form-signin border p-4 rounded">
    <form [formGroup]="purchaseOrderForm" (ngSubmit)="submit()">
      <div [formGroupName]="'purchaseOrderFields'">
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="form-floating">
              <select formControlName="purchaseOrderMadeById" id="purchaseOrderMadeById" class="form-control"
                [class.is-invalid]="submitted && purchaseOrderForm.get('purchaseOrderFields')?.get('purchaseOrderMadeById')?.errors">
                <option value=null disabled>Select User</option>
                <option *ngFor="let user of purchaseOrderUsers" [value]="user.id">{{ user.username
                  }}
                </option>
              </select>
              <label for="purchaseOrderMadeById">Made By <span class="text-danger">*</span></label>
              <span
                *ngIf="submitted && purchaseOrderForm.get('purchaseOrderFields')?.get('purchaseOrderMadeById')?.errors"
                class="text-danger">Client is required</span>
            </div>
          </div>
          <!-- Dropdown 2 -->
          <div class="col-md-6">
            <div class="form-floating">
              <select formControlName="purchaseOrderAssignedToId" id="purchaseOrderAssignedToId" class="form-control"
                [class.is-invalid]="submitted && purchaseOrderForm.get('purchaseOrderFields')?.get('purchaseOrderAssignedToId')?.errors">
                <option value=null disabled>Select User</option>
                <option *ngFor="let user of purchaseOrderUsers" [value]="user.id">{{ user.username
                  }}
                </option>
              </select>
              <label for="purchaseOrderAssignedToId">Assign To <span class="text-danger">*</span></label>
              <span
                *ngIf="submitted && purchaseOrderForm.get('purchaseOrderFields')?.get('purchaseOrderAssignedToId')?.errors"
                class="text-danger"> Assign To is
                required</span>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <!-- Quote Id -->
          <div class="col-md-3">
            <div class="form-floating">
              <input type="text" [disabled]="true" class="form-control" id="purchaseOrderId"
                formControlName="purchaseOrderId" />
              <label for="purchaseOrderId">PO Id</label>
            </div>
          </div>
          <!-- Purchase Order Date -->
          <div class="col-md-3">
            <div class="form-floating">
              <input type="date" class="form-control" id="purchaseOrderDate" formControlName="purchaseOrderDate" />
              <label for="purchaseOrderDate">Purchase Order Date <span class="text-danger">*</span></label>
              <span *ngIf="submitted && purchaseOrderForm.get('purchaseOrderFields')?.get('purchaseOrderDate')?.errors"
                class="text-danger">
                Date is required
              </span>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-floating">
              <select formControlName="purchaseOrderVendorId" id="purchaseOrderVendorId" class="form-control"
                [class.is-invalid]="submitted && purchaseOrderForm.get('purchaseOrderFields')?.get('purchaseOrderVendorId')?.errors"
                (change)="onCompanyChange()">
                <option value=null disabled>Select Vendor</option>
                <option *ngFor="let vendor of masterCommonServices?.vendorList" [value]="vendor.id">{{
                  vendor.vendorName }}</option>
              </select>
              <label for="purchaseOrderVendorId">Vendor <span class="text-danger">*</span></label>
              <span
                *ngIf="submitted && purchaseOrderForm.get('purchaseOrderFields')?.get('purchaseOrderVendorId')?.errors"
                class="text-danger">Company is required</span>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-floating">
              <select formControlName="purchaseOrderAttentionId" id="purchaseOrderAttentionId" class="form-control"
                [class.is-invalid]="submitted && purchaseOrderForm.get('purchaseOrderFields')?.get('purchaseOrderAttentionId')?.errors">
                <option value=null disabled>Select Attention</option>
                <option *ngFor="let member of vendorMembersList" [value]="member.id">{{ member.memberName }}</option>
              </select>
              <label for="purchaseOrderAttentionId">Attention <span class="text-danger">*</span></label>
              <span
                *ngIf="submitted && purchaseOrderForm.get('purchaseOrderFields')?.get('purchaseOrderAttentionId')?.errors"
                class="text-danger">Attention
                is
                required</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 mt-5">
        <h3><strong>Purchase Order Preview</strong></h3>
      </div>
      <div class="border p-2 rounded">
        <!-- Table for items -->

        <div class="row mb-3">
          <div class="col-md-12">
            <button type="button" class="btn btn-primary mb-3" (click)="addRow()">Add Row</button>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th class="col-sr-no">Sr No</th>
                  <th class="col-description1">
                    Description1 <span class="text-danger"
                      *ngIf="purchaseOrderItems.length > 0 && hasVisibleRows()">*</span>
                  </th>
                  <th class="col-description2">
                    Description2 <span class="text-danger"
                      *ngIf="purchaseOrderItems.length > 0 && hasVisibleRows()">*</span>
                  </th>
                  <th class="col-quantity">Quantity <span class="text-danger"
                      *ngIf="purchaseOrderItems.length > 0 && hasVisibleRows()">*</span></th>
                  <th class="col-unit">
                    Unit <span class="text-danger" *ngIf="purchaseOrderItems.length > 0 && hasVisibleRows()">*</span>
                    <div class="mt-2">
                      <button type="button" class="btn btn-sm btn-primary" (click)="openAddUpdateUnitDialog()"
                        title="Add Unit">
                        +
                      </button>
                    </div>
                  </th>
                  <th class="col-unit">
                    HSN <span class="text-danger" *ngIf="purchaseOrderItems.length > 0 && hasVisibleRows()">*</span>
                  </th>
                  <th class="col-unit-price">Unit Price <span class="text-danger"
                      *ngIf="purchaseOrderItems.length > 0 && hasVisibleRows()">*</span></th>
                  <th class="col-total-price">Total Price <span class="text-danger"
                      *ngIf="purchaseOrderItems.length > 0 && hasVisibleRows()">*</span></th>
                  <th class="col-item-inwardQuantity">Inward<br>Quantity</th>
                  <th class="col-actions">Actions</th>
                </tr>
              </thead>
              <tbody formArrayName="purchaseOrderItems">
                <ng-container *ngFor="let item of purchaseOrderItems.controls; let i = index">
                  <tr *ngIf="item.get('isDeleted')?.value !== true" [formGroupName]="i">

                    <td class="col-sr-no">{{ getSerialNumber(i) }}</td>
                    <td class="col-description1">
                      <textarea class="form-control auto-resize" formControlName="description1" rows="1"
                        (input)="autoResize($event)"></textarea>
                      <span *ngIf="submitted && item.get('description1')?.errors && hasVisibleRows()"
                        class="text-danger">
                        Description1 is required
                      </span>
                    </td>
                    <td class="col-description2">
                      <textarea class="form-control auto-resize" formControlName="description2" rows="1"
                        (input)="autoResize($event)"></textarea>
                      <span *ngIf="submitted && item.get('description2')?.errors && hasVisibleRows()"
                        class="text-danger">
                        Description2 is required
                      </span>
                    </td>
                    <td class="col-quantity"><input type="number" (ngModelChange)="onPurchaseOrderItemFieldChanged(i)"
                        class="form-control" formControlName="quantity">
                      <span *ngIf="submitted && item.get('quantity')?.errors && hasVisibleRows()" class="text-danger">
                        Quantity is required
                      </span>
                    </td>
                    <td class="col-unit">
                      <div class="d-flex align-items-center">
                        <select class="form-control me-2" formControlName="unit">
                          <option value="" disabled selected>Select Unit</option>
                          <option *ngFor="let unit of masterCommonServices?.unitsList" [value]="unit.id">
                            {{ unit.unitName }}
                          </option>
                        </select>
                      </div>
                      <span *ngIf="submitted && item.get('unit')?.invalid && hasVisibleRows()" class="text-danger">
                        Please select a unit
                      </span>
                    </td>
                    <td class="col-hsn">
                      <div class="d-flex align-items-center">
                        <select class="form-control me-2" formControlName="hsn">
                          <option value="" disabled selected>Select HSN</option>
                          <option *ngFor="let hsn of masterCommonServices?.hsnList" [value]="hsn.id">
                            {{ hsn.hsnName }}
                          </option>
                        </select>
                      </div>
                      <span *ngIf="submitted && item.get('hsn')?.invalid && hasVisibleRows()" class="text-danger">
                        Please select a hsn
                      </span>
                    </td>
                    <td class="col-unit-price"><input type="number" (ngModelChange)="onUnitPriceChanged(i)"
                        class="form-control" formControlName="unitPrice">
                      <span *ngIf="submitted && item.get('unitPrice')?.errors && hasVisibleRows()" class="text-danger">
                        Unit Price is required
                      </span>
                    </td>
                    <td class="col-total-price"><input type="number" class="form-control" formControlName="totalPrice"
                        value="0"></td>
                    <td class="col-inwardQuantity"><input type="number" class="form-control"
                        formControlName="inwardQuantity">
                    </td>
                    <td class="col-actions">
                      <button type="button" class="btn btn-danger btn-sm" (click)="removeRow(i)">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>

        <div class="row mb-3 justify-content-end border-top p-3" [formGroupName]="'purchaseOrderFields'">
          <div class="col-md-2">
            <div class="summary-fields d-flex flex-column align-items-end">
              <div class="form-floating mb-3">
                <input type="number" class="form-control" id="netTotal" formControlName="netTotal" [disabled]="true" />
                <label for="netTotal">Net Total</label>
              </div>
              <div class="form-floating mb-3">
                <select (ngModelChange)="calculateGrandTotal()" formControlName="discountType" id="discountType"
                  class="form-control">
                  <option value=null disabled>Select Percent</option>
                  <option value="percent">Percent</option>
                  <option value="value">Value</option>
                </select>
                <label for="discountType">Discount Type</label>
              </div>
              <div class="form-floating mb-3">
                <input (ngModelChange)="calculateGrandTotal()" type="number" class="form-control" id="discount"
                  formControlName="discount" />
                <label for="discount">Discount</label>
              </div>
              <div class="form-floating mb-3">
                <input (ngModelChange)="calculateGrandTotal()" type="number" class="form-control" id="otherCharges"
                  formControlName="otherCharges" />
                <label for="otherCharges">P&F Charges</label>
              </div>
            </div>
          </div>
          <div class="row justify-content-end border-tops p-3">
            <div class="col-md-3">

              <div class="d-flex align-items-center">
                <div class="form-check me-2">
                  <input type="checkbox" class="form-check-input" id="removeGst" formControlName="isGstRemoved"
                    (change)="onToggleRemoveGst()" />
                  <label class="form-check-label" for="removeGst">Remove GST</label>
                </div>
                <div class="form-floating mb-3">
                  <input type="number" class="form-control" id="gstAmount" formControlName="gstAmount"
                    [disabled]="true" />
                  <label for="gstAmount">GST Amount</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3 justify-content-end border-tops p-3">
            <div class="col-md-3">

              <div class="d-flex align-items-center mb-3">
                <div class="form-check me-2">
                  <input type="checkbox" class="form-check-input" id="roundOff" formControlName = "isRoundOff" (change)="toggleRoundOff($event)" />
                  <label class="form-check-label" for="roundOff">Round off</label>
                </div>
                <div class="flex-grow-1" style="max-width: 100%;">
                  <div class="form-floating">
                    <input type="number" class="form-control" id="grandTotal" formControlName="grandTotal"
                      [disabled]="true" />
                    <label for="grandTotal"><b>Grand Total</b></label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div [formGroupName]="'purchaseOrderTerms'">
        <div class="row mb-3 mt-5">
          <div class="col-md-12">
            <h3><strong>Terms and Conditions</strong></h3>
          </div>
          <div class="col-md-6">
            <div class="form-floating mb-3">
              <select formControlName="deliveryNameId" class="form-control">
                <option value=null>Select Delivery</option>
                <option *ngFor="let option of masterCommonServices?.deliveredTosList" [value]="option.id">{{
                  option.deliveryName }}</option>
              </select>
              <label for="deliveryNameId">Delivered To</label>

            </div>
          </div>

          <div class="col-md-6">
            <div class="form-floating mb-3">
              <select formControlName="currencyId" class="form-control">
                <option value=null>Select Currency</option>
                <option *ngFor="let option of masterCommonServices?.currenciesList" [value]="option.id">{{
                  option.currencyName }}</option>
              </select>
              <label for="currencyId">Currency</label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating mb-3">
              <!-- Calendar input for Delivery Date -->
              <input type="date" class="form-control" formControlName="deliveryTime" id="deliveryTime">
              <label for="deliveryTime">Delivery Time</label> <!-- Floating label for the input -->
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating mb-3">
              <select formControlName="countryofOriginId" class="form-control">
                <option value=null>Select Country Of Origin</option>
                <option *ngFor="let option of masterCommonServices?.countriesList" [value]="option.id">{{
                  option.countryName }}</option>
              </select>
              <label for="countryofOriginId">Country Of Origin</label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating mb-3">
              <select formControlName="paymentId" class="form-control">
                <option value=null>Select Payment</option>
                <option *ngFor="let option of masterCommonServices?.paymentsList" [value]="option.id">{{
                  option.paymentType }}</option>
              </select>
              <label for="paymentId">Payment</label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating mb-3">
              <select formControlName="mtcTypeId" class="form-control">
                <option value=null>Select MTC Type</option>
                <option *ngFor="let option of masterCommonServices?.mtcTypesList" [value]="option.id">{{
                  option.mtcType }}
                </option>
              </select>
              <label for="mtcTypeId">MTC Type</label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating mb-3">
              <select formControlName="validityId" class="form-control">
                <option value=null>Select Validity</option>
                <option *ngFor="let option of masterCommonServices?.validitiesList" [value]="option.id">{{
                  option.validity
                  }}</option>
              </select>
              <label for="validityId">Validity</label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating mb-3">
              <select formControlName="packingTypeId" class="form-control">
                <option value=null>Select Packing Type</option>
                <option *ngFor="let option of masterCommonServices?.packingTypesList" [value]="option.id">{{
                  option.transportMode }}</option>
              </select>
              <label for="packingTypeId">Packing Type</label>
            </div>
          </div>
        </div>
      </div>
      <!-- Submit Button -->
      <div class="row mb-3">
        <div class="col-md-12">
          <button type="submit" class="btn btn-primary" [disabled]="purchaseOrderForm.invalid || purchaseOrderForm.pristine">Submit</button>
        </div>
      </div>
    </form>
  </main>

</div>